import { fetcher } from "@/lib/api/fetcher";
import { environments } from "@/lib/config";
import { ResponseData } from "@/types/common";
import { CommonCDType } from "@/types/common-cd";

const apiUrl = environments.restApiUrl;

export const getCommonCDByCodes = (codes: string[]) => {
  return fetcher<ResponseData<CommonCDType[]>>(
    `${apiUrl}/common/by-grp-codes`,
    { method: "POST", body: { grp_codes: codes } }
  );
};
export async function FetchTerm(locale: string) {
  const res = await fetch(`${apiUrl}/common/policy`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Accept-Language": locale,
    },
  });
  if (!res.ok) {
    const error = await res.text();
    throw new Error(`Request failed: ${res.status} - ${error}`);
  }

  return res.json();
}

export const updateUserLanguage = (language: string) => {
  return fetcher(`${apiUrl}/user/language`, {
    method: "PATCH",
    body: { language }
  })
}
